import { VisualSuper } from "./visual-super.component.js";

class Canvas extends VisualSuper {
  namespace = "visual:canvas";
}

const canvas = new Canvas();
export { Canvas, canvas };
